/**
 * Minimum time in milliseconds to display loading states.
 * Prevents UI flicker for fast-loading content.
 */
export const MIN_LOADING_DISPLAY_MS = 1000
